import { LoadExamQuestionsQuery } from '../../pool/lib/services/exam/load-exam-questions.generated';
import { LoadExamListQuery } from '../../pool/lib/services/exam/load-exams.generated';

export type Exam = LoadExamListQuery['pool']['exams'][0];

export type ExamQuestions = LoadExamQuestionsQuery['exam'];

export type ExamQuestionGroup =
  LoadExamQuestionsQuery['exam']['bookletA']['examQuestionGroups'][0];
export type ExamQuestionGroupQG =
  LoadExamQuestionsQuery['exam']['bookletA']['examQuestionGroups'][0]['questionGroup'];
export type ExamQuestionGroupQGId =
  LoadExamQuestionsQuery['exam']['bookletA']['examQuestionGroups'][0]['questionGroup']['id'];

export enum BookletType {
  A = 'A',
  B = 'B'
}

export enum ExamTabs {
  ExamQuestions = 'examQuestions',
  Candidates = 'candidates'
}

export enum UnlockStrategy {
  Revoke = 'revoke',
  Confirmation = 'confirmation',
  Security = 'security'
}

export enum LockState {
  Locked = 'locked',
  Unlocked = 'unlocked'
}

export enum Booklet {
  A = 'bookletA',
  B = 'bookletB'
}
